<div class="holidays">
  @if (this.lastHoliday; as h) {
    <span [class.clickable]="readonly" (click)="openLeave()">{{ Globals.fromDateString(h.start_on) > this.today ? (Globals.fromDateString(h.start_on) | date:'longDate') + (Globals.fromDateString(h.end_on).getTime() !== Globals.fromDateString(h.start_on).getTime() ? ' - ' + (Globals.fromDateString(h.end_on) | date:'longDate') : '') :  (Globals.fromDateString(h.start_on) <= today && Globals.fromDateString(h.end_on) >= today ? ('until' | translate:{value: (Globals.fromDateString(h.end_on) | date:'longDate')}) : ('noupcomingleave' | translate)) }}</span>
  }
  @if (!this.lastHoliday) {
    <span [class.clickable]="readonly" (click)="openLeave()">{{ ('noupcomingleave' | translate) }}</span>
  }
  @if (!readonly) {
    <button nbButton size="tiny" type="button" (click)="openLeave()"><nb-icon icon="edit-2-outline"></nb-icon><span>{{ (disabled || readonly ? 'viewleave' : 'setleave') | translate }}</span></button>
  }
  @if (readonly && quickAdd) {
    <button nbButton size="tiny" type="button" (click)="openLeaveQuick()"><nb-icon icon="plus-outline"></nb-icon><span>{{ 'setleave' | translate }}</span></button>
  }
</div>
